import parseHtml from "html-react-parser";
import Head from "next/head";
import constants from "src/constants";
import { OgData } from "src/functions/getOg";

type Props = {
  data: OgData;
};

export default function Headers({ data }: Props) {
  const fbPixelNoScript = `
    <noscript>
      <img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=300079365168860&ev=PageView&noscript=1" />
    </noscript>
  `;

  const gtmNoScript = `
    <noscript>
      <iframe src="https://www.googletagmanager.com/ns.html?id=${constants.Marketing.gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>
    </noscript>
  `;

  return (
    <Head>
      <title>{data.title}</title>
      <link rel="shortcut icon" href="/favicon.png" />
      {data.metas.map((meta, index) => {
        return (
          <meta key={index} property={meta.property} content={meta.content} />
        );
      })}
      <link
        rel="stylesheet"
        href="https://maxcdn.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css"
        integrity=""
        crossOrigin="anonymous"
      />
      <link
        rel="stylesheet"
        type="text/css"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
      />
      <link
        rel="stylesheet"
        type="text/css"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
      />
      {process.env.NODE_ENV !== "development" && (
        <>
          <meta
            name="facebook-domain-verification"
            content="hv8prnhvu2ofkcxcaa7ivls15gsbz8"
          />
          {parseHtml(fbPixelNoScript)}
          {parseHtml(gtmNoScript)}
        </>
      )}
    </Head>
  );
}
